import Vue from 'vue'
import Router from 'vue-router'
// import LoginMain from '@/views/login/loginMain'
// import authorizeMain from '@/views/login/AuthorizeMain'
import HomeMain from '@/views/home/HomeMain'
import MovieDetail from '@/views/home/MovieDetail'
import ProfileMain from '@/views/profile/ProfileMain'
import AppointmentRecords from '@/views/profile/AppointmentRecords'
import PaymentRecords from '@/views/profile/PaymentRecords'
import MembershipCards from '@/views/profile/MembershipCards'
import Moviegoers from '@/views/profile/Moviegoers'

Vue.use(Router)


const router = new Router({
    routes: [
        // {
        //     path: '/',
        //     name: 'authorizeMain',
        //     component: authorizeMain,
        //     meta: { hideTabbar: true }
        // },
        // {
        //     path: '/login',
        //     name: 'loginMain',
        //     component: LoginMain,
        //     meta: { hideTabbar: true }
        // },
        {
            path: '/',
            name: 'homeMain',
            component: HomeMain
        },
        {
            path: '/movie-detail',
            name: 'movieDetail',
            component: MovieDetail,
            meta: { hideTabbar: true }
        },
        {
            path: '/profile',
            name: 'profileMain',
            component: ProfileMain
        },
        {
            path: '/appointment-records',
            name: 'appointmentRecords',
            component: AppointmentRecords,
            meta: { hideTabbar: true }
        },
        {
            path: '/payment-records',
            name: 'paymentRecords',
            component: PaymentRecords,
            meta: { hideTabbar: true }
        },
        {
            path: '/membership-cards',
            name: 'membershipCards',
            component: MembershipCards,
            meta: { hideTabbar: true }
        },
        {
            path: '/moviegoers',
            name: 'moviegoers',
            component: Moviegoers,
            meta: { hideTabbar: true }
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }
        return { x: 0, y: 0 }
    }

})

// 注：去掉强制 afterEach 顶部回滚，保留浏览器返回时的滚动恢复
export default router